export const CART_TEST_ID = {
  content: 'cart-content',
  urlActionModal: 'url-action-modal',
  networkErrorModal: 'network-error-modal',
  duplicateLeadModal: 'duplicate-lead-modal',
  duplicateAccountModal: 'duplicate-account-modal',
  otpContactSalesModal: 'otp-contact-sales-modal',
  claimedOtpAccountModal: 'claimed-otp-account-modal',
};

export const CART_PRODUCT_IDS = {
  NO_HARDWARE: 'NO_HARDWARE',
};
